import ErrorPage from 'layouts/pages/error-page/ErrorPage';
import LandingPage from 'layouts/pages/landing-page/LandingPage';
import PrivacyPolicyPage from 'layouts/pages/privacy-policy-page/PrivacyPolicyPage';
import TermsAndConditionPage from 'layouts/pages/terms-and-conditions-page/TermsAndConditionPage';
import LoadingScreen from 'navigation/LoadingScreen';
import React, { Suspense } from 'react';
import {
	createBrowserRouter,
	createRoutesFromElements,
	Route,
	RouterProvider,
} from 'react-router-dom';
import App from '../App';
import { PRIVACY_POLICY, ROOT, TERMS_AND_CONDITION } from './Routes.ts';

export default function RouterConfig() {
	const router = createBrowserRouter(
		createRoutesFromElements(
			<Route path={ROOT} element={<App />} errorElement={<ErrorPage />}>
				<Route index element={<LandingPage />} />
				<Route path={PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
				<Route path={TERMS_AND_CONDITION} element={<TermsAndConditionPage />} />
				<Route element={<LandingPage />} />
				<Route errorElement={<ErrorPage />}>
					<Route
						path="*"
						element={
							<Suspense fallback={<LoadingScreen />}>
								<ErrorPage />
							</Suspense>
						}
					/>
				</Route>
			</Route>,
		),
	);

	return <RouterProvider router={router} />;
}
